import { useEffect, useState } from 'react';

// Define the return type
type ThemeProviderReturnType = [string, () => void];

const SiteThemeProvider = (): ThemeProviderReturnType => {
    // Initialize theme from local storage or set a default theme
    const storedTheme = localStorage.getItem('theme');
    const defaultTheme = storedTheme || 'light';
    const [theme, setTheme] = useState(defaultTheme);

    useEffect(() => {
        // Update the class on the root element to apply the theme
        const root = window.document.documentElement;
        root.classList.remove('light', 'dark');
        root.classList.add(theme);

        // Save the theme to local storage
        localStorage.setItem('theme', theme);
    }, [theme]);  // Only depend on `theme` to avoid redundant updates

    // Function to toggle the theme
    const toggleTheme = () => {
        setTheme((prevTheme) => (prevTheme === 'dark' ? 'light' : 'dark'));
    };
    return [theme, toggleTheme];
};

export default SiteThemeProvider;
